import i18n from '../../locales/index'
import { genBasicStore } from '../vuex'
import assign from 'lodash/assign';
import axios from 'axios';

const store = genBasicStore('wxa_wechat')

assign(store.actions, {
  async find_one ({ commit }) {
    const res = await axios.get('wxa_wechats/find_one')
    commit('setRecord', res.data)
  }
})

export default store;
